export const MINUTES_PER_DAY_MAX = 1440;

export const parseValidMinutes = (value: string | number | null | undefined) => {
  const normalized = String(value ?? "").trim();
  if (!/^\d+$/.test(normalized)) {
    return null;
  }

  const parsed = Number(normalized);
  if (!Number.isInteger(parsed) || parsed < 1 || parsed > MINUTES_PER_DAY_MAX) {
    return null;
  }

  return parsed;
};

export const getMinutesValidationError = (
  value: string | number | null | undefined,
  minimum = 1
) => {
  const parsed = parseValidMinutes(value);
  if (parsed == null) {
    return `Enter valid minutes between 1 and ${MINUTES_PER_DAY_MAX}.`;
  }

  if (parsed < minimum) {
    return `Minimum ${minimum} minutes is required.`;
  }

  return null;
};
